export const versionCode = "0.2.39";
export const versionNumber = 239;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  versionCode,
  versionNumber,
};
